var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"personal_access"},[_c('p',{staticClass:"personal_access__description"},[_vm._v(" Нажимая кнопку “Отправить”, "),_c('br'),_vm._v(" вы соглашаетесь с "),_c('a',{staticClass:"link_default",attrs:{"href":"#"}},[_vm._v("условиями использования")])])])
}]

export { render, staticRenderFns }